export const NumberFormatter = (value: any, locale?: any, currency?: any) =>
  new Intl.NumberFormat(locale ?? "en-MY", {
    style: "currency",
    currency: currency ?? "MYR",
  }).format(value);